<div class="form-modal">
    <h1 mat-dialog-title>{{'EMAILS'|translate}}</h1>
    <div mat-dialog-content>
        <div class="form-group">
  
          <!-- Panel da Tabela de Utilizadores -->
          <div class="col-md-12">
            <div class="panel panel-default">
              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup2"
                (click)="collPnPopup2 = !collPnPopup2">
                <h5 class="panel-title">
                  <i class="fas fa-pencil-alt"></i>
                  <strong> {{'EMAILS'|translate}}</strong>
                  <i class="collapse-icon fas"
                    [ngClass]="{'fa-caret-down': collPnPopup2, 'fa-caret-up': !collPnPopup2}"></i>
                </h5>
              </div>
              <div id="collPnPopup2" class="panel-body no-horizontal-padding collapse in">
                  <mat-form-field class="full-width">
                    <mat-label>{{'EMAILS'|translate}}</mat-label>
                    <textarea matInput [(ngModel)]="emailsCSV"></textarea>
                  </mat-form-field>
                  <span class="emailInfo">{{'EMAIL_INFO_SEMICOLON'|translate}}</span>
              </div>  
              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup1"
                (click)="collPnPopup1 = !collPnPopup1">
                <h5 class="panel-title">
                  <i class="fas fa-users"></i>
                  <strong> {{'USERS'|translate}}</strong>
                  <i class="collapse-icon fas"
                    [ngClass]="{'fa-caret-down': collPnPopup1, 'fa-caret-up': !collPnPopup1}"></i>
                </h5>
              </div>
              <div id="collPnPopup1" class="panel-body no-horizontal-padding collapse in">
                  <table id="tabelaWorkflowUsers" class="table table-bordered display" cellspacing="0">
                    <thead>
                      <tr>
                        <th>
                          <strong>{{ 'NAME'| translate}}</strong>
                        </th>
                        <th></th>
                      </tr>
                      <tr>
                        <th>
                          <mat-form-field class="full-width findInputContainer">
                            <mat-label>{{'FILTER'|translate}}</mat-label>
                            <input type="text" matInput class="findInput">
                          </mat-form-field>
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>  
            </div>
          </div>
        </div>
    </div>
    <div mat-dialog-actions>
      <div class="full-width text-right">
        <button type="button" class="btn btn-default" (click)="dialogRef.close(null)">
          <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">
          <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
        </button>
      </div>
    </div>
  </div>